import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.8 2.95A7.848 7.848 0 0 0 7.625 1C4.138 1 1.19 3.272.155 6.415L1.925 7a6.002 6.002 0 0 1 5.7-4.125 5.98 5.98 0 0 1 3.84 1.41L8.75 7h6.75V.25l-2.7 2.7Z",
  fill: "#616161"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };